import { Image, ImageProps } from 'theme-ui'

const Beefy = (props: ImageProps) => {
  return <Image width={16} src="/imgs/beefy.png" {...props} />
}
export default Beefy
